import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ForgotPasswordFormTW } from '../../components/auth/ForgotPasswordFormTW';
import { useLenis } from '../../hooks/useLenis';

export const ForgotPasswordPageTW: React.FC = () => {
  useLenis();
  const navigate = useNavigate();

  return (
    <ForgotPasswordFormTW
      onBackToLogin={() => navigate('/login')}
    />
  );
};
